import * as React from "react";
function SvgAdd(props) {
  return <svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="currentColor"><path d="M0 5h12v2H0z" /><path d="M5 12V0h2v12z" /></g></svg>;
}
export default SvgAdd;